<div id="page-wrapper" class="d-flex flex-column w-100">
    <app-navigation></app-navigation>
    <router-outlet></router-outlet>
    <app-footer class="mt-auto"></app-footer>
</div>